import { jsx as o } from "react/jsx-runtime";
import { Dropdown as t } from "../../foundations/icons/Dropdown.js";
const p = ({
  className: r,
  cx: d,
  innerProps: i
}) => /* @__PURE__ */ o("div", { ...i, className: d({ indicator: !0, "dropdown-indicator": !0 }, r), children: /* @__PURE__ */ o(t, {}) });
export {
  p as DropdownIndicator
};
//# sourceMappingURL=DropdownIndicator.js.map
